import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';
import MessageUtils from "../../../../utils/MessageUtils";
import {
    LOADING,
    LOAD_TAX_SETTINGS_SUCCESS,
    SAVE_TAX_SETTINGS_SUCCESS,
    CLEAR_TAX_SETTINGS
} from '../../../types';

export const loadTaxSettings = (restaurantId) => {
    return (dispatch) => {

        if (Number(restaurantId) !== -1) {

            dispatch({ type: LOADING, payload: true });

            const url = `/restaurant-settings/${restaurantId}/taxes`;

            axios().get(url)
                .then(response => loadTaxSettingsSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response, i18n.t('actions:taxSettingsActions.loadTaxSettingsFailure')));
        }
    };
};

const loadTaxSettingsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_TAX_SETTINGS_SUCCESS, payload: response.data });
};

export const saveTaxSettings = (restaurantId, taxSettings) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant-settings/${restaurantId}/taxes`;

        axios().put(url, taxSettings)
            .then(response => saveTaxSettingsSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:taxSettingsActions.saveTaxSettingsFailure')));
    };
};

export const saveTaxSettingsPixelPoint = (restaurantId, taxSettings) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant-settings/${restaurantId}/taxes`;

        axios().post(url, taxSettings)
            .then(response => saveTaxSettingsSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:taxSettingsActions.saveTaxSettingsFailure')));
    };
};

const saveTaxSettingsSuccess = (dispatch, response) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:taxSettingsActions.saveTaxSettingsSuccess'));

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: SAVE_TAX_SETTINGS_SUCCESS, payload: response.data });
};

export const clearTaxSettings = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_TAX_SETTINGS });
    }
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/restaurant/TaxSettingsActions.js